module.exports = __webpack_public_path__ + "img/VectorRed.a1b59420.svg";